var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disabled && !_vm.content)?_c('span',{class:_vm.className},[_vm._v("\n  Upload files\n")]):(_vm.content)?_c('span',{class:_vm.className},[_vm._v("\n  "+_vm._s(_vm.content)+"\n")]):(!_vm.disabled)?_c('span',{class:_vm.className},[_c('UploadIcon',{staticClass:"vue-fine-uploader-gallery-dropzone-upload-icon"}),_vm._v("\n  Drop files here\n")],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e13be6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-fineuploader/gallery/MaybeDropzoneContent.vue
// module id = ZOaG
// module chunks = 0